var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "defaultLayout"
    }
  }, [_c('section', {
    attrs: {
      "id": "NAV"
    }
  }, [_c('MyHeader', {
    attrs: {
      "cur-locale": _vm.locale,
      "locale-list": _vm.localeList
    },
    on: {
      "i18n:update": _vm.updateI18n
    }
  })], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "MAIN"
    }
  }, [_c('Nuxt')], 1), _vm._v(" "), _c('MyFooter', {
    attrs: {
      "synopsis-visible": _vm.synopsisVisible
    }
  }), _vm._v(" "), _vm.$store.state.isLoading ? _c('Loading') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }